import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { SDK } from '@plugins/middleware-sdk';

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  protected http = inject(HttpClient);
  protected sdk = inject(SDK);

  protected baseUrl = '/api/user-details';
  private profileCache$?: Observable<Record<string, unknown>>;

  getProfileFull(): Observable<Record<string, unknown>> {
    if (!this.profileCache$) {
      this.profileCache$ = this.http
        .get<Record<string, unknown>>(`${this.baseUrl}/profile/full`)
        .pipe(shareReplay(1));
    }
    return this.profileCache$;
  }

  getProfileUrl(userId: string) {
    return this.sdk.getUserProfileUrl(userId);
  }

  async openProfile(userId: string) {
    const url = await this.sdk.getUserProfileUrl(userId);
    if (url) {
      this.sdk.openLink(url);
    }
  }
}
